import { Area } from "./AreaHierarchy"

export class Building extends Area {
    static entity = 'buildings'

    // Reference to base entity name.
    static baseEntity = 'areas'

    // Call `super.fields()`` to merge fields.
    static fields() {
        return {
            ...super.fields()
        }
    }
}

// We also export a default.
export default Building;